/**
 * Client-side token utilities.
 * Actual unique token generation happens server-side (DB default: gen_random_bytes).
 * These helpers construct the public URLs that are embedded in outgoing emails.
 */

const APP_URL = import.meta.env.VITE_APP_URL ?? window.location.origin;

/** URL a recipient clicks to respond (Accept / Reject / Query) */
export function buildCTAUrl(ctaToken: string): string {
  return `${APP_URL}/respond/${ctaToken}`;
}

/** 1×1 transparent pixel URL — when loaded it records an email open */
export function buildTrackingPixelUrl(trackToken: string): string {
  return `${APP_URL}/track/${trackToken}`;
}

/** Inject both the CTA URL and tracking pixel into an HTML email body */
export function injectEmailTokens(
  bodyHtml: string,
  ctaToken: string,
  trackToken: string
): string {
  const ctaUrl   = buildCTAUrl(ctaToken);
  const pixelUrl = buildTrackingPixelUrl(trackToken);

  let result = bodyHtml;

  // Replace placeholder tokens that templates use
  result = result.replaceAll('{{CTA_URL}}',     ctaUrl);
  result = result.replaceAll('{{TRACK_PIXEL}}', `<img src="${pixelUrl}" width="1" height="1" alt="" style="display:block;border:0;"/>`);
  result = result.replaceAll('{{ACCEPT_URL}}',  `${ctaUrl}?action=accept`);
  result = result.replaceAll('{{REJECT_URL}}',  `${ctaUrl}?action=reject`);
  result = result.replaceAll('{{QUERY_URL}}',   `${ctaUrl}?action=query`);

  return result;
}

/** Interpolate template variables like {{CANDIDATE_NAME}}, {{JOB_TITLE}}, etc. */
export function interpolateTemplate(
  template: string,
  vars: Record<string, string>
): string {
  return Object.entries(vars).reduce(
    (t, [key, val]) => t.replaceAll(`{{${key}}}`, val),
    template
  );
}
